export default {
  methods: {
    alignClasses (column, row = {}) {
      let cellClassName = ''
      if (row.cellClassName && column.key && row.cellClassName[ column.key ]) {
        cellClassName = row.cellClassName[ column.key ]
      }
      return [
        {
          [`${cellClassName}`]: cellClassName, // cell className
          [`${column.className}`]: column.className, // column className
          [`text-${column.align}`]: column.align
          // [`${this.prefixCls}--hidden`]: (this.fixed === 'left' &&
          // column.fixed !== 'left') ||
          // (this.fixed === 'right' && column.fixed !== 'right') ||
          // (!this.fixed && column.fixed &&
          // (column.fixed === 'left' || column.fixed === 'right'))
        }
      ]
    },
    isPopperShow (column) {
      return column.filters && ((!this.fixed && !column.fixed) ||
        (this.fixed === 'left' && column.fixed === 'left') ||
        (this.fixed === 'right' && column.fixed === 'right'))
    },
    setCellWidth (column, index, top) {
      let width = ''
      if (column.width) {
        width = column.width
      } else if (this.columnsWidth[ column._index ]) {
        width = this.columnsWidth[ column._index ].width
      }
      // when browser has scrollBar,set a width to resolve scroll position bug
      if (width && this.columns.length === index + 1 && top &&
        this.$parent.bodyHeight !== 0) {
        width += this.$parent.scrollBarWidth
      }
      if (width === '0') width = ''
      return width
    },
    createLine (x1, y1, x2, y2, line, options) {
      options = Object.assign({
        color: '',
        stroke: '',
        style: '',
        class: ''
      }, options)
      var isIE = navigator.userAgent.indexOf('MSIE') > -1
      if (x2 < x1) {
        var temp = x1
        x1 = x2
        x2 = temp
        temp = y1
        y1 = y2
        y2 = temp
      }
      if (options.class) {
        line.className = options.class
      }
      var length = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2))
      line.style.width = length + 'px'
      if (options.stroke) {
        line.style.borderBottomWidth = options.stroke + 'px '
      }
      if (options.style) {
        line.style.borderBottomStyle = options.style
      }
      if (options.color) {
        line.style.borderColor = options.color
      }
      line.style.position = 'absolute'
      // line.style.zIndex = options.zindex
      if (isIE) {
        line.style.top = (y2 > y1) ? y1 + 'px' : y2 + 'px'
        line.style.left = x1 + 'px'
        var nCos = (x2 - x1) / length
        var nSin = (y2 - y1) / length
        line.style.filter = 'progid:DXImageTransform.Microsoft.Matrix(sizingMethod="auto expand", M11=' + nCos + ', M12=' + -1 * nSin + ', M21=' + nSin + ', M22=' + nCos + ')'
      } else {
        var angle = Math.atan((y2 - y1) / (x2 - x1))
        line.style.top = y1 + 0.5 * length * Math.sin(angle) + 'px'
        line.style.left = x1 - 0.5 * length * (1 - Math.cos(angle)) + 'px'
        line.style.transform = line.style.MozTransform = line.style.WebkitTransform = line.style.msTransform = line.style.OTransform = 'rotate(' + angle + 'rad)'
      }
      return line
    },
    getCoordinate (target) {
      var result = {
        x1: target.offsetLeft,
        y1: target.offsetTop
      }
      if (!isNaN(result.x1)) {
        result.x2 = result.x1 + target.offsetWidth
        result.y2 = result.y1 + target.offsetHeight
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/table/mixin.js